import React, { useState, useEffect, createContext } from "react";
import { MemoizedDetail } from "./Detail";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContractorBillingService from "../../services/ContractorBillingService";
import { MessageAlert } from "../../components/Components";
import appSettings from "../../utils/AppSetting";

const formDataContext = createContext();

const BillingDetail = (props) => {
  const { billing, isModal, isHideTitle, setIsOpenModalBillingDetail } = props;
  const contractorBillingService = ContractorBillingService();
  const { t } = useTranslation();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenTable, setIsOpenTable] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [isClickSearch, setIsClickSearch] = useState(false);
  const [getBillingRs, setGetBillingRs] = useState(null);
  const pageCount = Math.ceil(totalRecordCount / pageSize);
  const [getBillingRq, setGetBillingRq] = useState(null);
  const [statusList, setStatusList] = useState(null);

  const SetPageChange = async () => {
    setGetBillingRq((prev) => {
      return {
        ...prev,
        startRow: (page - 1) * pageSize,
        pageSize: pageSize,
      };
    });
  };

  const GetBilling = async (rq) => {
    try {
      setIsLoading(true);
      setIsOpenTable(false);

      const response = await contractorBillingService.GetBilling(rq);
      setIsLoading(false);
      if (response.isSuccess) {
        setGetBillingRs(response?.result);
        setTotalRecordCount(response?.result?.totalRecord);
      } else {
        if (setIsOpenModalBillingDetail != null) {
          setIsOpenModalBillingDetail(false);
        }
        MessageAlert.error({
          title: "แจ้งเตือน",
          message: `${response.statusCode} - ${response.statusMessage}`,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching details:", error);
    }
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);
  const fetchData = async () => {
    let objInput = isModal ? billing : location.state;
    setGetBillingRq((prev) => {
      return {
        ...prev,
        advno: objInput?.advno,
        lotno: objInput?.lotno,
        startRow: 0,
        pageSize: pageSize,
      };
    });
    setStatusList(await getConfig(appSettings.configKey.jobStatus));
  };
  useEffect(() => {
    if (getBillingRq != null) {
      GetBilling(getBillingRq);
      return () => {};
    }
  }, [getBillingRq]);

  useEffect(() => {
    if (isClickSearch) {
      SetPageChange();
    }
  }, [page, pageSize, isClickSearch]);

  const getConfig = async (paramKey, displayDialog) => {
    try {
      setIsLoading(true);
      let listWorker = await contractorBillingService.GetConfig({
        paramType: paramKey,
      });
      if (!listWorker?.isSuccess) throw new Error(listWorker?.statusMessage);
      setIsLoading(false);
      return listWorker?.result?.configList;
    } catch (error) {
      setIsLoading(false);
      if (displayDialog) {
        MessageAlert.error({
          title: t("Error"),
          message: t("InternalError"),
        });
      }
      return null;
    }
  };

  return (
    <>
      <formDataContext.Provider
        value={{
          page,
          setPage,
          pageSize,
          setPageSize,
          totalRecordCount,
          setTotalRecordCount,
          isClickSearch,
          setIsClickSearch,
          pageCount,
          getBillingRq,
          getBillingRs,
          isModal,
          isHideTitle,
          statusList,
        }}
      >
        <MemoizedDetail isLoading={isLoading} isOpenTable={isOpenTable} />
      </formDataContext.Provider>
    </>
  );
};

export { formDataContext };
export default BillingDetail;
